var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":"","fill-height":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"shrink":""}},[_c('v-progress-circular',{attrs:{"size":120,"color":"sz_red","indeterminate":""}}),_c('AppLogo',{staticClass:"relative-to-progress",attrs:{"width":"44"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }